import Banner from '../../components/Banner'
import { Helmet } from 'react-helmet'
import CapacityIcon from '../../assets/icons/CapacityIcon'
import ReceptionIcon from '../../assets/icons/ReceptionIcon'
import ComputerIcon from '../../assets/icons/ComputerIcon'
import PrivateImage from '../../assets/offices/private.webp'
import Image1 from '../../assets/offices/services-1.webp'
import Image2 from '../../assets/offices/services-2.webp'
import Image3 from '../../assets/offices/services-3.webp'
import Image4 from '../../assets/about-us/image-3.webp'
import FlexImage from '../../assets/offices/flex.webp'
import CTA from '../../components/CTA'
import WhatsAppButton from '../../components/WhatsAppButton'


const ITEMS = [
  {
    title: 'Recepción:',
    description: 'Nos encargamos de recibir y acompañar a tus visitas.',
    icon: <ReceptionIcon width={40} height={40} className='text-orange'/>
  }, {
    title: 'Equipamiento:',
    description: 'Tv con conexión HDMI, pizarra, uso de cocinas bazar e infusiones y ambiente climatizado.',
    icon: <ComputerIcon width={40} height={40} className='text-orange'/>
  }
]

const MODES = [
  {
    title: 'Oficina exclusiva',
    description: <div className='d-flex flex-column gap-1'>
      <span>Ideal para empresas que valoran la privacidad, el confort y el alto rendimiento.</span>
      <span>Acceso todos los días, infraestructura premium, servicios todo incluido y opción de personalización.</span>
      <span>Un espacio profesional e inspirador para hacer crecer tu negocio sin distracciones.</span>
    </div>,
    image: PrivateImage
  }, {
    title: 'Oficina privada flex',
    description: <div className='d-flex flex-column gap-1'>
      <span> De 1 a 4 veces por semana, tu espacio privado con la libertad del modelo híbrido.</span>
      <span>Pensada para empresas dinámicas que buscan flexibilidad sin resignar confort ni calidad.</span>
      <span>Con infraestructura premium y entorno profesional, es la solución ideal para equipos que quieren crecer, adaptarse y mantenerse productivos en cada etapa. </span>
    </div>,
    image: FlexImage
  }
]

const SERVICES = [
  {
    title: 'Salas de reunión y video call',
    description: 'Salas completamente equipadas para tus reuniones y videollamadas. Conexión HDMI, pizarras y acceso a cocina e infusiones.',
    image: Image1
  }, {
    title: 'Comunidad Vida',
    description: 'Formá parte de una comunidad emprendedora y colaborativa. En Vida, conectás, creás y creces junto a otros profesionales.',
    image: Image2
  }, {
    title: 'Espacio Verde',
    description: '500 m² diseñados para inspirar. Un entorno natural para trabajar al aire libre, realizar reuniones o simplemente tomar un respiro y reconectar.',
    image: Image3
  }, {
    title: 'Market Vida',
    description: 'Un autoservicio honesto con productos seleccionados para acompañar y potenciar tu jornada laboral.',
    image: Image4
  }
]


const Offices = () => {
  return (
    <>
      <Helmet>
        <title>Vida Cowork: Oficinas privadas</title>
      </Helmet>

      <main className='Offices'>
        <Banner
          title='Oficinas privadas'
          description='En nuestro espacio los equipos nacen, evolucionan y se expanden'
          message='¡Hola! Quisiera reservar una oficina privada en Vida'
          titleFullWidth
          whatsappIconLeft
          contact='5493516202588'
        />

        <section className="Offices__Info container-custom">
          <div className="d-flex flex-column gap-2">
            <p className='text-3 fw-medium text-green'>
              ¿Por qué contratar una oficina en Vida?
            </p>

            <p className='text-4'>
              Porque te permite enfocarte al 100% en tu crecimiento. Te ofrecemos un espacio flexible, profesional y totalmente equipado, pensado para potenciar tu productividad y bienestar desde el primer día.
              Sumamos experiencias de team building para fortalecer a tu equipo, impulsar el sentido de pertenencia y ayudarte a atraer y retener talento.
              Todo esto, en un entorno natural que inspira. Menos distracciones, más foco en lo que realmente importa.
            </p>
          </div>

          <div className="d-flex flex-column justify-content-evenly align-items-center gap-4">
            {ITEMS.map((item, index) => (
              <div
                key={`Office-Item-${index}`}
                className="Offices__Info-Item"
              >
                { item.icon }
                <div className="d-flex flex-column gap-2">
                  <p className="text-3 fw-medium text-orange">
                    { item.title }
                  </p>
                  <p className="text-4">
                    { item.description }
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="Offices__Modes container-custom">
          <p className='caption text-green'>
            Tenemos dos modalidades de oficinas privadas para ofrecerte
          </p>

          {MODES.map((mode, index) => (
            <div
              key={`Office-Mode-${index}`}
              className="Offices__Modes-Item"
            >
              <img
                className='Offices__Modes-Image'
                src={mode.image}
                alt={mode.title}
                title={mode.title}
              />

              <div className="Offices__Modes-Text">
                <p className="text-1 fw-medium text-orange">
                  { mode.title }
                </p>

                { mode.description }

                <WhatsAppButton
                  label="Reservar ahora"
                  message={`¡Hola! Quisiera reservar una "${mode.title.toLowerCase()}" en Vida`}
                  withIconLeft
                  contact='5493516202588'
                />
              </div>
            </div>
          ))}
        </section>

        <section className="Offices__Services container-fluid">
          <div className="Offices__Services-Tramas"></div>

          <div className="Offices__Services-Content container-custom">
            <p className='caption text-white fw-medium z-1'>
              Servicios que incluye el espacio
            </p>

            <div className="Offices__Services-Items">
              {SERVICES.map((service, index) => (
                <div
                  key={`Office-Service-${index}`}
                  className="Offices__Services-Item"
                >
                  <img
                    className='Offices__Services-Image'
                    src={service.image}
                    alt={service.title}
                    title={service.title}
                  />

                  <div className="Offices__Services-Text">
                    <p className="text-3 fw-bold text-green">
                      { service.title }
                    </p>

                    <p className="text-5">
                      { service.description }
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <CTA
          title={
            <div className='d-flex flex-column gap-2 title text-green'>
              ¡VIDALIZATE!
              <p
                style={{
                  color: '#616161',
                  fontSize: '24px'
                }}
              > Descubrí cómo nuestras oficinas pueden transformar tu manera de trabajar</p>
            </div>
          }
          cta='¡Haz clic acá para reservar tu oficina ya!'
          message='¡Hola! Quisiera reservar una oficina privada en Vida'
          whatsappIconLeft
          contact='5493516202588'
        />
      </main>
    </>
  )
}

export default Offices